(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('MonitoringRuleErrorHistory', MonitoringRuleErrorHistory);

    MonitoringRuleErrorHistory.$inject = ['$resource'];

    function MonitoringRuleErrorHistory($resource) {
        return $resource('api/monitoring-rule-error-history', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'updateProcessed': {
                method: 'GET',
                url: 'api/monitoring-rule-error-history/:uuidExecution/processed'
            }
        });
    }
})();
